// ============================================
// HEADER STATIC DATA (MENUS)
// Translation keys and URLs for navigation
// ============================================

// TypeScript Interfaces
interface LodgeItem {
  nameKey: string
  url: string
  comingSoon?: boolean
}

interface NavItem {
  nameKey: string
  url: string
  hidden?: boolean
}

interface RegionItem {
  regionKey: string
  lodges: LodgeItem[]
}

// Lodge destination structure with translation keys
export const lodgeDestinationsData: RegionItem[] = [
  {
    regionKey: "laParvaChile",
    lodges: [
      { nameKey: "apexMountainPenthouse", url: "/lodges/apex-mountain-penthouse" },
      { nameKey: "apexParvaCave", url: "/lodges/apex-parva-cave" }
    ]
  },
  {
    regionKey: "farellonesChile",
    lodges: [
      { nameKey: "apexPremiumLodge", url: "/lodges/apex-premium-lodge", comingSoon: true }
    ]
  },
  {
    regionKey: "patagoniaChile",
    lodges: [
      { nameKey: "apexYelchoPatagonia", url: "/lodges/apex-yelcho-patagonia" },
      { nameKey: "apexPatagoniaLodge", url: "/lodges/apex-patagonia-lodge" }
    ]
  },
  {
    regionKey: "araucaniaChile",
    lodges: [
      { nameKey: "apexLakefrontSerenity", url: "/lodges/apex-lakefront-serenity", comingSoon: true }
    ]
  }
]

// Adventure structure with translation keys
export const adventuresData: NavItem[] = [
  { nameKey: "resortSkiing", url: "/guided-adventures/resort-skiing" },
  { nameKey: "heliSkiing", url: "/guided-adventures/heli-skiing" },
  { nameKey: "skiTouring", url: "/guided-adventures/ski-touring" },
  { nameKey: "catSkiing", url: "/guided-adventures/cat-skiing", hidden: true },
  { nameKey: "flyFishing", url: "/guided-adventures/fly-fishing" },
  { nameKey: "waterSkiing", url: "/guided-adventures/water-skiing", hidden: true }
]

// Experiences structure with translation keys
export const experiencesData: NavItem[] = [
  { nameKey: "laparvaSignature", url: "/experiences/laparva-signature" },
  { nameKey: "wineRoute", url: "/experiences/wine-route" },
  { nameKey: "catamaranTrip", url: "/experiences/catamaran-trip" },
  { nameKey: "privateDinners", url: "/experiences/private-dinners-santiago" },
  { nameKey: "mountainServices", url: "/experiences/mountain-services" },
  { nameKey: "mountainExtras", url: "/experiences/mountain-extras" }
]
